import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GameStateResponse, PlayerStateUpdate } from 'src/app/dto';
import { AnnouncementNotification } from 'src/app/services/signal.service';

@Component({
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss'],
    standalone: false,
    // initialize() is called exactly once, synchronously, right after NgbModal creates this
    // component (RandomEventService.receiveNotification) and never again over its lifetime -
    // equivalent to a construction-time write for OnPush purposes.
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementComponent {
    name: string;
    body: string;
    imagePath: string;
    announcement: AnnouncementNotification;

    // Handed straight to app-critter-state-update - the same "You gained/You lose" summary
    // card item use and quest rewards already render, rather than the hand-rolled string
    // concatenation (with a "$" prefix instead of the crittercoin icon) this component used to
    // build itself. Only PlayerStateUpdate is populated - the other GameStateResponse fields
    // (PetChanges/Messages/LottieId) are undefined, which app-critter-state-update already
    // guards against.
    stateUpdate: GameStateResponse;
    hasStateChange = false;

    constructor(public activeModal: NgbActiveModal) { }

    public initialize(announcement: AnnouncementNotification): void {
        this.announcement = announcement;
        this.body = this.announcement.body;
        this.name = this.announcement.title;
        this.imagePath = this.announcement.eventInformation.ImagePath;

        const playerStateUpdate: PlayerStateUpdate = this.announcement.eventInformation.PlayerStateUpdate;
        this.stateUpdate = <GameStateResponse>{ PlayerStateUpdate: playerStateUpdate };
        this.hasStateChange = !!playerStateUpdate && (
            (playerStateUpdate.AddedItems && playerStateUpdate.AddedItems.length > 0) ||
            (playerStateUpdate.RemovedItems && playerStateUpdate.RemovedItems.length > 0) ||
            !!playerStateUpdate.CashChangedAmount);
    }

    public close(): void {
        this.activeModal.close();
        this.announcement.onClose();
    }
}
